<template>
  <Modal
    :modal-active="modelValue"
    has-header-border
    has-footer-border
    max-width="max-w-[520px]"
    @close="emit('update:modelValue', false)"
  >
    <template #header>
      <h2 class="text-xl font-bold text-textPrimary text-left">Avançar para conciliação</h2>
    </template>

    <div class="flex flex-col gap-3 text-left">
      <p class="text-sm text-textPrimary">
        {{ emptyRowsMessage }}
      </p>
      <p class="text-sm text-neutral50">
        O envio para conciliação não pode ser desfeito. Cancele para continuar preenchendo a folha.
      </p>
    </div>

    <template #footer>
      <div class="flex flex-col sm:flex-row sm:justify-end gap-3">
        <OutlineButton
          text="Cancelar"
          width="96px"
          height="40px"
          data-testid="discard-empty-rows-cancel-button"
          @click="emit('update:modelValue', false)"
        />
        <FilledButton
          text="Confirmar avanço"
          class="bg-primary30"
          width="180px"
          height="40px"
          :disabled="saving"
          data-testid="discard-empty-rows-confirm-button"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

const props = defineProps<{
  modelValue: boolean
  saving: boolean
  emptyRowCount: number
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
}>()

// RN-10: o descarte das linhas vazias acontece exatamente neste clique e não aparece
// no payload — a confirmação é o que dá ciência dele ao auditor.
const emptyRowsMessage = computed(() => {
  if (props.emptyRowCount === 0) return 'Todas as linhas preenchidas serão enviadas à conciliação.'
  return props.emptyRowCount === 1
    ? '1 linha vazia não será enviada à conciliação.'
    : `${props.emptyRowCount} linhas vazias não serão enviadas à conciliação.`
})
</script>
